// Lista de funções que são usadas para mandar os sockets quanod adiciona, exclui ou edita uma tarefa
export default {
  /* eslint-disable eqeqeq */
  data: () => ({}),
  methods: {
    methodAddTaskSocket (task) {
      if (task.level === 1) {
        // se o nível for 1, quer dizer que não é subtarefa de ninguém.
        // Enviando evento de manipulação de itens
        // Object.assign(task, {route: 'Tasks'})
        for (let participant in task.participants) {
          this.$socket.emit('generalEvent', {
            data: task,
            responseEvent: 'addSocketItem',
            room: `tasks${task.participants[participant]}`
          })
          // Adicionar a tarefa nas tarefas do calendário
          this.$socket.emit('generalEvent', {
            data: task,
            responseEvent: 'addSocketCalendarTask',
            room: `calendar${task.participants[participant]}`
          })
        }
      } else {
        // Socket para atualizar as subtarefas quando o usuário estiver na tela de gerenciamento
        this.$socket.emit('generalEvent', {
          data: task,
          responseEvent: 'addTaskSubTask',
          notBroadcast: true,
          room: `tasks${task.task_id}_manage`
        })
        // Enviando evento de manipulação de subtarefas
        for (let participant in task.participants) {
          this.$socket.emit('generalEvent', {
            data: task,
            responseEvent: 'addSubTask',
            room: `tasks${task.participants[participant]}`
          })
          // Adicionar a tarefa nas tarefas do calendário
          this.$socket.emit('generalEvent', {
            data: task,
            responseEvent: 'addSocketCalendarTask',
            room: `calendar${task.participants[participant]}`
          })
        }
      }
    },
    methodDeleteTaskSocket (task) {
      //* Envio de eventos para todos os usuários que possuem tempo rodando
      task.task_durations.forEach((userId) => {
        this.$socket.emit('generalEvent', {
          data: {active: false},
          notBroadcast: true,
          responseEvent: 'changeStopWatch',
          room: `user${userId}`
        })
      })
      //* Envio de eventos de exclusão da tarefa para os usuários que não possuem nenhum tipo de participação nela.
      this.$socket.emit('generalEvent', {
        data: {text: `Esta tarefa foi excluída. Será necessário recarregar a página.`, delTask: task.delTaskUsers},
        responseEvent: 'reloadPageModules',
        room: `${this.entity}${task.id}_manage`
      })
      if (task.level === 1) {
        this.$socket.emit('generalEvent', {
          data: {id: task.id, delTaskUsers: task.delTaskUsers},
          responseEvent: 'deleteSocketItem',
          room: this.socketRoom
        })
        for (let prop in task.delTaskUsers) {
          this.$socket.emit('generalEvent', {
            data: task,
            responseEvent: 'deleteSocketCalendarTask',
            room: `calendar${task.delTaskUsers[prop]}`
          })
          this.$socket.emit('generalEvent', {
            data: task,
            responseEvent: 'deleteSocketItem',
            room: `tasks${task.delTaskUsers[prop]}`
          })
        }
      } else {
        // Socket para atualizar a subtarefa quando o usuário estiver na tela de gerenciamento
        this.$socket.emit('generalEvent', {
          data: task.id,
          responseEvent: 'deleteTaskSubTask',
          notBroadcast: true,
          room: `tasks${task.task_id}_manage`
        })

        for (let user in task.participants) {
          this.$socket.emit('generalEvent', {
            data: task,
            responseEvent: 'deleteSubTask',
            room: `tasks${task.participants[user]}`
          })
        }
      }
      if (this.deleteFiles) {
        this.$socket.emit('generalEvent', {
          data: {many: true, task_id: task.id},
          responseEvent: 'deleteSocketItem',
          room: `files${this.$auth.user().company_id}`
        })
      }
    },
    // reloadTask usado pois em um momento recarrega a pagina, porem quando é kanban não precisa
    // notBroadcast usado para quando for necesssário atualizar a propria pagina, no caso de estar com o gerenciamento d etarefas habilitado eeditar a tarefa pela consulta (status)
    methodEditTaskSocket (task, beforeTask = {}, reloadTask = true, notBroadcast = false) {
      // A edição pode vir de varios lugares como mudança de status, editar a tarefa pela taskeditable, mudar o status pelo kanban etc
      // Coloca alguns valores antigos como o usuário para verificar se o usuário mudou e tratar o registro de acordo e verificar se o status mudou e tratar no kanban
      let taskAux = {} // Utiliza variavel "taskAux" para não precisar alterar valores do val ao adicionar a tarefa.
      // O taskAux recebe o task e depois os valorse de users e old, o users e old devem vir depois pois caso o task tenha esses valores prevalece os passados enão do task
      Object.assign(taskAux, task, {users: task.users, old_status: ((beforeTask !== {} && beforeTask.status) ? beforeTask.status : task.status)})
      let resBody = task
      if (resBody.recurrence_id === null) taskAux.recurrence = {type: '', id_text: {each: '', days: '', months: ''}}
      // deleção do campo de crud acces para que o usuario mantenha seu acesso no socket
      delete taskAux.crud_access
      // Quando é o kanban e edita alguma tarefa, o registr é adicionad
      if (resBody.level === 1) {
        /**
         * Inserimos 3 itens adicionais no objeto "data" a ser passado como parametro para o evento:
         * old_status -> Com o objetivo de verificar o status antigo no kanban para alterar o item de acordo com o status
         * users -> com o objetivo de termos os observadores para fazer a verificação. Porque quando muda o responsável da tarefa, temos que
         * old_user_id -> (Ja vem do back) com o objetivo ter o antigo responsável da tarefa e sabermos se o responsável foi alterado. Porem do PSelectStatus não vem do back
         * verificar se o antigo responsável continua como observador, pois se continuar, não podemos excluir a tarefa para ele, e sim
         * editar o responsável.
         * Após fazer a edição do registro no allItems, enviamos o evento.
         */
        if ((taskAux.user_id !== taskAux.old_user_id) && taskAux.user_id > 0) {
          this.$socket.emit('generalEvent', {
            data: taskAux,
            responseEvent: 'addSocketItem',
            room: `tasks${taskAux.user_id}`
          })
          this.$socket.emit('generalEvent', {
            data: taskAux,
            responseEvent: 'addSocketCalendarTask',
            room: `calendar${taskAux.user_id}`
          })
        }
        this.$socket.emit('generalEvent', {
          data: {values: taskAux, entity: 'tarefa'},
          responseEvent: 'editSocketManagementDetails',
          notBroadcast: notBroadcast,
          room: `tasks${task.id}_manage`
        })
        for (let user in task.delTaskUsers) {
          this.$socket.emit('generalEvent', {
            data: taskAux,
            responseEvent: 'deleteSocketItem',
            room: `tasks${task.delTaskUsers[user]}`
          })
          this.$socket.emit('generalEvent', {
            data: taskAux,
            responseEvent: 'deleteSocketCalendarTask',
            room: `calendar${task.delTaskUsers[user]}`
          })
          this.$socket.emit('generalEvent', {
            data: task.status ? [task.status.id_text] : ['Sem Status'],
            responseEvent: 'reloadStatusPageByName',
            room: `kanban${task.delTaskUsers[user]}`
          })
        }
        // Nível !== 1 quer dizer que é uma subtarefa sendo editada...
      } else {
        // Socket para atualizar a subtarefa quando o usuário estiver na tela de gerenciamento
        this.$socket.emit('generalEvent', {
          data: taskAux,
          responseEvent: 'editTaskSubTask',
          notBroadcast: true,
          room: `tasks${task.task_id}_manage`
        })

        for (let user in task.participants) {
          this.$socket.emit('generalEvent', {
            data: taskAux,
            responseEvent: 'editSubTask',
            room: `tasks${task.participants[user]}`
          })
          // Caso tenha sido finalizado ou desfinalizado uma tarefa recarrega a pagina por socket para atualizar a quantidade de tarefas finalizadas
          if ((taskAux.old_status['identifier'] == 3 && taskAux.status['identifier'] != 3) || (taskAux.old_status['identifier'] != 3 && taskAux.status['identifier'] == 3)) {
            // quando mudar o status chama o emit de recarregar a pagina pra recarregar a pagina do proprio usuário
            if (reloadTask) {
              this.$emit('reloadTasks')
            }
            // Socket para alterar a quantidade de subtarefas finalizadas
            let valuesFinalize = {
              id: taskAux['id'],
              top_id: taskAux['top_id'],
              task_id: taskAux['task_id'],
              level: taskAux['level'],
              tree_task_sequence: taskAux['tree_task_sequence'],
              type: taskAux.status['identifier'] == 3 ? 'add' : 'del'
            }
            this.$socket.emit('generalEvent', {
              data: valuesFinalize,
              responseEvent: 'socketQtdFinalizeSubTask',
              notBroadcast: true,
              room: `tasks${task.participants[user]}`
            })
          }
        }
        this.$socket.emit('generalEvent', {
          data: {values: taskAux, entity: 'tarefa'},
          responseEvent: 'editSocketManagementDetails',
          notBroadcast: notBroadcast,
          room: `tasks${task.id}_manage`
        })
      }
      for (let prop in taskAux.participants) {
        this.$socket.emit('generalEvent', {
          data: taskAux,
          responseEvent: 'editSocketItem',
          room: `tasks${taskAux.participants[prop]}`
        })
      }
      for (let prop in taskAux.participants) {
        this.$socket.emit('generalEvent', {
          data: taskAux,
          responseEvent: 'editSocketCalendarTask',
          room: `calendar${taskAux.participants[prop]}`
        })
        // this.$socket.emit('generalEvent', {
        //   data: (beforeTask.task_status_id !== resBody.task_status_id) ? [resBody.status ? resBody.status.id_text : ['Sem Status'], beforeTask.status ? beforeTask.status.id_text : ['Sem Status']] : [resBody.status ? resBody.status.id_text : ['Sem Status']],
        //   notBroadcast: true,
        //   responseEvent: 'reloadStatusPageByName',
        //   room: `kanban${resBody.participants[prop]}`
        // })
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixin/methodTaskSocket.js